import api from './api';

interface Protagonist {
  name: string;
}

const protagonist = async (): Promise<Protagonist> => (
  api.get('people/1/')
    .then((res) => res.data)
    .catch(() => console.error('[Service - StarWars] Não foi possível buscar o protagonista'))
);

export default { protagonist };
